/* globals CN_COMMITHASH */
// Vue stuff
import { createApp } from 'vue'
import App from './App'
import router from './router'
import { createPinia } from 'pinia'

// Modules
import * as Sentry from '@sentry/vue'
import './registerServiceWorker'

// Polyfill
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer'

// Tests for old browsers or scripts (no console.* || no window.* || ie 7-10 || Opera Mini)
if (typeof console === 'undefined' ||
    typeof window === 'undefined' ||
    (document.all && window.XMLHttpRequest) ||
    Object.prototype.toString.call(window.operamini) === '[object OperaMini]') {
  let errorMsgUnsupported = '<h1>CN Schedule</h1>'
  errorMsgUnsupported += '<p><b>You\'re currently using an unsupported browser</b>.<br/>'
  errorMsgUnsupported += 'Please upgrade to the latest version of Chrome, Opera, Brave, Firefox, Microsoft Edge or Safari to continue.</p>'

  document.getElementById('jserror').innerHTML = errorMsgUnsupported
  throw new Error('Unsupported browser')
}

// Apply polyfill
window.ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill

// Create our app
const cnApp = createApp(App)

// Plug the modules
cnApp.use(router)
cnApp.use(createPinia())

// Don't include tracking in dev
if (import.meta.env.PROD) {
  Sentry.init({
    app: cnApp,
    dsn: 'https://0b508e3600154112a79ec13710202d20@glitch.rita.moe/5',
    environment: import.meta.env.MODE || import.meta.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({
        router
      })
    ],
    logErrors: true,
    release: CN_COMMITHASH,
    tracePropagationTargets: [
      /https:\/\/[a-z0-9-]+\.cn-schedule\.pages\.dev/,
      'schedule.ctoon.network'
    ],
    tracesSampleRate: 0.4
  })

  const yum = document.createElement('script')
  yum.setAttribute('src', 'https://yum.rita.moe/yum.js')
  yum.setAttribute('defer', '')
  yum.dataset.websiteId = '2ea265a0-8369-40c8-bdb6-eb248b82eef6'
  document.body.appendChild(yum)
}

// LET'S GOOOOOOO
cnApp.mount('#app')
